import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "api";
import { STATUS } from "utils/status";
import { AnalyticsExpertState, AnalyticsPayload } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/analyticsExpertExtraReducer';

const initialState: AnalyticsExpertState = {
  analyticsExpert: {
    count: undefined,
    results: []
  },
  error: null,
  getStatus: STATUS.NOT_STARTED,
  downloadAnalyticsByExpertStatus: STATUS.NOT_STARTED,
  analyticsExpertDownload: '',
  getExpertAnalyticsMessage: "",
  getExpertAnalyticsDownloadMessage: ""
};

export const getExpertAnalytics = createAsyncThunk(
  'project/qa-analytics/overview/taskbyexpert/get',
  async (payload: AnalyticsPayload = { association_type: '' }, thunkAPI) => {
    try {
      const { search, page, pageSize, sort_by, sort_order, project_id, association_type, download, chip, tab, stage_id, granularity, start_date, end_date } = payload;
      const response = await api.get('project/qa-analytics/overview/', {
        params: {
          search,
          page,
          page_size: pageSize,
          sort_by,
          sort_order,
          project_id,
          tab: tab || 'experts',
          chip,
          association_type,
          download,
          stage_id,
          granularity,
          start_date,
          end_date,
        },
      });
      const { status, data } = response;
      if (status === 200) {
        const mappedData = data?.data || data;
        return {
          count: mappedData?.count ?? 0,
          results: mappedData?.results || [],
          accepted_percentage: mappedData?.accepted_percentage ?? 0,
          rejected_percentage: mappedData?.rejected_percentage ?? 0,
          accepted_count: mappedData?.accepted_count ?? 0,
          rejected_count: mappedData?.rejected_count ?? 0,
          total_reviewed: mappedData?.total_reviewed ?? 0,
          top_error_type: mappedData?.top_error_type ?? '',
          error_type_breakdown: mappedData?.error_type_breakdown || [],
          rejection_reasons: mappedData?.rejection_reasons || [],
        };
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

export const getExpertAnalyticsDownload = createAsyncThunk(
  '/task/company/analytics/by_expert/get/download',
  async (payload: AnalyticsPayload = { association_type: '' }, thunkAPI) => {
    try {
      const { search, page, pageSize, sort_by, sort_order, project_id, type, association_type, download } = payload;
      const response = await api.get('task/company/analytics/download_tasks_by_experts', {
        params: {
          search,
          page,
          page_size: pageSize,
          sort_by,
          sort_order,
          project_id,
          type,
          association_type,
          download,
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

const analyticsExpertsSlice = createSlice({
  name: 'analyticsExpert',
  initialState,
  reducers: {
    setDownloadAnalyticsByExpertStatus: (state, actions) => {
      state.downloadAnalyticsByExpertStatus = actions.payload
    }
  },
  extraReducers
});

export const { setDownloadAnalyticsByExpertStatus } = analyticsExpertsSlice.actions
export default analyticsExpertsSlice.reducer;


